/**
 * TrialBanner — barra sutil no topo durante o trial.
 */
import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface TrialBannerProps {
  diasRestantes: number;
  onUpgrade?: () => void;
  onDismiss?: () => void;
}

const TrialBanner: React.FC<TrialBannerProps> = ({ diasRestantes, onUpgrade, onDismiss }) => {
  const urgente = diasRestantes <= 2;
  const aviso = diasRestantes <= 4;

  // Cores por urgência
  const bg = urgente
    ? 'bg-red-600'
    : aviso
    ? 'bg-amber-500'
    : 'bg-indigo-600';

  const label =
    diasRestantes === 0
      ? 'Trial expira hoje'
      : diasRestantes === 1
      ? 'Último dia de trial'
      : `Trial · ${diasRestantes} dias restantes`;

  return (
    <div className={`${bg} text-white`}>
      <div className="flex items-center justify-center gap-3 px-4 py-1.5 text-[12px] sm:text-[13px]">
        <span className="font-medium">{label}</span>
        <span className="hidden sm:inline text-white/60">·</span>
        <button
          onClick={onUpgrade}
          className="hidden sm:inline font-semibold underline underline-offset-2 decoration-white/40 hover:decoration-white transition-colors"
        >
          Ver planos
        </button>
        <button
          onClick={onUpgrade}
          className="sm:hidden font-semibold text-[11px] bg-white/20 px-2.5 py-0.5 rounded-full"
        >
          Ver planos
        </button>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="absolute right-3 p-0.5 rounded hover:bg-white/15 transition-colors"
          >
            <XMarkIcon className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default TrialBanner;
